
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery-and-shipping-costs",
      function () {
        return require("private-next-pages/delivery-and-shipping-costs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery-and-shipping-costs"])
      });
    }
  